import { render, staticRenderFns } from "./Licence.vue?vue&type=template&id=0bf6e7b3&"
import script from "./Licence.vue?vue&type=script&lang=ts&"
export * from "./Licence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports